import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnClick(props) {
  let selected = useDataValue({
    viewPath: props.viewPath,
    path: 'selected',
    context: 'sort',
  })

  let change = useDataChange({
    context: 'sort',
    path: 'selected',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let value = {
      ...Object.fromEntries(Object.keys(selected).map(key => [key, null])),
    }
    change(value)
  }
}
